import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  getFilter() {
    return http.get(endpoints.get('resourceFilter'), {
      withCredentials: true
    })
  }
}
